export type CreditCardType = 'Visa' | 'MasterCard' | 'AmericanExpress' | 'Discover' | 'JCB';
